import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchRun } from "../api.js";
import StatusBadge from "../components/StatusBadge.jsx";

export default function RunDetail() {
  const { runId } = useParams();
  const [run, setRun] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const j = await fetchRun(runId);
        if (!cancelled) setRun(j);
      } catch (e) {
        if (!cancelled) setError(String(e.message || e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [runId]);

  if (loading) return <p>Loading run…</p>;
  if (error) return <div className="error">{error}</div>;
  if (!run) return null;

  const results = run.results || [];

  return (
    <>
      <p>
        <Link to="/">← Services</Link>
        {run.serviceName && (
          <>
            {" "}
            /{" "}
            <Link to={`/services/${encodeURIComponent(run.serviceName)}`}>
              {run.serviceName}
            </Link>
          </>
        )}
      </p>
      <h1>Run {run.runId}</h1>
      <p>
        <StatusBadge status={run.status} /> {run.summary || ""}
        {run.runningTimeSeconds != null && run.status === "RUNNING" && (
          <span style={{ marginLeft: "0.5rem", color: "#71767b" }}>
            ({run.runningTimeSeconds}s)
          </span>
        )}
      </p>
      <table>
        <thead>
          <tr>
            <th>Test</th>
            <th>Result</th>
            <th>HTTP</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {results.map((t, i) => (
            <tr key={i}>
              <td>{t.name}</td>
              <td>{t.passed ? "PASS" : "FAIL"}</td>
              <td>
                {t.actual_status != null ? t.actual_status : "—"} /{" "}
                {t.expected_status != null ? t.expected_status : "—"}
              </td>
              <td style={{ wordBreak: "break-word", maxWidth: "360px" }}>
                {t.detail || (t.response_snippet ? t.response_snippet.slice(0, 200) : "")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
